angular.module('leanlaw').controller('MattersEditCtrl', ['$scope', 'company', '$stateParams', 'leanLawApi', 'userService', '$state', 'accountingService', function ($scope, company, $stateParams, leanLawApi, userService, $state, accountingService) {
  $scope.openEdit = false;
  $scope.loading = false;
  $scope.loadingClient = false;
  $scope.chosenValid = false;
  userService.me().then(me => {
    $scope.user = me;
    $scope.company = me.company;
  });
  $scope.matter = {};
  $scope.data = {
    client: {},
    users: [],
    newUser: null,
    matterUsers: [],
    originating: [],
    clients: [],
    fixed: {}
  };
  $scope.roles = [{
    id: 'primary',
    name: 'Primary Responsible'
  }, {
    id: 'responsible',
    name: 'Responsible'
  }, {
    id: 'other',
    name: 'Time Keeper'
  }, {
    id: 'remove',
    name: '- Remove -'
  }];
  function convertRates(rates) {
    const result = rates.other || [];
    if (rates.standard) {
      result.push({
        label: 'Standard',
        amount: rates.standard
      });
    }
    return result;
  }
  const loadUsers = leanLawApi.listAccounts().then(list => {
    $scope.data.users = _.map(list.accounts, user => {
      const u = {
        id: user.id,
        name: user.name,
        rates: convertRates(user.rates)
      };
      u.standardRate = _.find(u.rates, r => r.label == 'Standard');
      return u;
    });
    return $scope.data.users;
  });
  leanLawApi.listClients({
    matters: "exclude",
    scope: "all",
    status: "all"
  }).then(list => {
    $scope.data.clients = list.clients;
  });
  if (!$stateParams.id || $stateParams.id == 'new') {
    $scope.matter = {
      opened: new Date(),
      billable: true,
      users: [],
      billing: {
        type: 'hours'
      }
    };
    loadUsers.then(users => {
      // when creating a matter, make the user the primary reposible
      const matterUser = _.find(users, u => $scope.user.id == u.id);
      matterUser.role = {
        id: 'primary'
      };
      matterUser.rate = matterUser.standardRate;
      $scope.data.matterUsers = [matterUser];
    });
  } else {
    leanLawApi.getMatter({
      id: $stateParams.id
    }).then(matter => {
      $scope.matter = matter;
      $scope.matter.opened = new Date(matter.opened);
      if ($scope.matter.billing.type == 'fixed') {
        if ($scope.matter.billing.fixed.label) {
          const existing = _.find($scope.company.settings.fixedFees, f => f.label == $scope.matter.billing.fixed.label);
          if (existing) {
            $scope.data.fixed = existing;
            $scope.matter.billing.fixed = angular.copy(existing);
          }
        }
      }
      if (matter.users) {
        loadUsers.then(users => {
          // Update matter.users into $scope.matterUsers and $scope.originating
          $scope.data.matterUsers = [];
          $scope.data.originating = [];
          _.each(matter.users, user => {
            const matterUser = _.find(users, u => user.id == u.id);
            _.each(user.roles, role => {
              if (role == 'originating') {
                $scope.data.originating.push(user);
              } else {
                matterUser.role = {
                  id: role
                };
                matterUser.rate = user.rate || matterUser.standardRate;
              }
            });
            if (matterUser.role) {
              $scope.data.matterUsers.push(matterUser);
            }
          });
        });
      }
    });
  }
  $scope.setFixed = function (fixed) {
    if (!fixed) {
      $scope.matter.billing.fixed = null;
      $scope.matter.billing.type = 'hours';
    } else {
      $scope.matter.billing.fixed = {
        amount: 0
      };
      $scope.clearStandard();
      $scope.matter.billing.type = 'fixed';
    }
  };
  $scope.rateChange = function (user) {
    // if a new rate is typed in, we clear the label
    user.rate = {
      label: '',
      amount: user.rate.amount
    };
  };
  $scope.roleChange = function (user) {
    // make sure there is only one primary responsible
    if (user.role.id == 'primary') {
      _.each($scope.data.matterUsers, u => {
        if (user.id !== u.id && u.role && u.role.id == 'primary') {
          u.role.id = 'responsible';
        }
      });
    }
    if (user.role.id == 'remove') {
      $scope.data.matterUsers.splice($scope.data.matterUsers.indexOf(user), 1);
    }
  };
  $scope.addUser = function (user) {
    // add user to matterUsers
    if (user.rates.length) {
      user.rate = user.standardRate;
    }
    user.role = {
      id: $scope.data.matterUsers.length ? 'other' : 'primary'
    };
    $scope.data.matterUsers.push(user);
    $scope.data.newUser = null;
  };
  $scope.roleOrder = function (user) {
    if (!user.role) return user.name;
    if (user.role.id == 'primary') return 0;
    if (user.role.id == 'responsible') return 1;
    if (user.role.id == 'other') return 2;
    return 3;
  };
  $scope.notPicked = function (user) {
    return !_.find($scope.data.matterUsers, u => u.id == user.id);
  };
  $scope.searchMatters = function (name) {
    if (!$scope.matter.client) return [];
    return leanLawApi.listClientMatters({
      id: $scope.matter.client.id,
      scope: 'all',
      status: 'active',
      search: name
    }).then(list => list.matters);
  };
  $scope.existingMatterSelected = function (matter) {
    if ($scope.matter.id) return;
    const status = [];
    const resolution = [];
    if (!matter.active) {
      status.push('is archived');
      resolution.push('activate');
    }
    if (!matter.involved) {
      if (matter.restricted) {
        status.push('has restricted access');
        resolution.push('request access to');
      } else {
        status.push('does not have you assigned');
        resolution.push('add yourself to');
      }
    }
    let prompt = `This ${$scope.me.terms.matter} is already in the system`;
    if (status.length > 0) {
      prompt += ` but ${status.join(' and ')}`;
    }
    prompt += ". ";
    if (resolution.length > 0) {
      prompt += `Would you like to ${resolution.join(' and ')}`;
    } else {
      prompt += "Use";
    }
    prompt += ` the existing ${$scope.me.terms.matter} instead of creating a new one?`;
    bootbox.confirm(prompt, result => {
      if (!result) return;
      if (!matter.active || !matter.involved) {
        leanLawApi.getMatter({
          id: matter.id
        }).then(detail => {
          const update = {};
          if (!matter.active) {
            update.active = true;
          }
          if (!matter.involved) {
            update.users = detail.users;
            update.users.push({
              id: $scope.user.id,
              roles: ['other']
            });
          }
          leanLawApi.updateMatter({
            id: matter.id,
            body: update
          }).then(() => {
            $state.go('^', {}, {
              reload: true
            });
          });
        });
      } else {
        $state.go('^');
      }
    });
  };
  $scope.saveMatter = function () {
    if (!$scope.matterForm.$valid) {
      return;
    }
    if (!$scope.matter.name.replace(/ /g, '')) {
      $scope.addAlert('danger', `${$scope.terms.Matter} name cannot be blank`);
      return;
    }
    if ($scope.matter.opened == undefined) {
      $scope.matter.opened = new Date();
    }
    // convert $scope.matterUsers and $scope.originating back into $scope.matter.users
    let hasPrimary = false;
    $scope.matter.users = [];
    _.each($scope.data.users, user => {
      const roles = [];
      const matterUser = _.find($scope.data.matterUsers, u => user.id == u.id);
      if (matterUser) {
        roles.push(matterUser.role.id);
        user.rate = matterUser.rate;
        if (matterUser.primary) hasPrimary = true;
      }
      if (_.find($scope.data.originating, u => u.id == user.id)) {
        roles.push('originating');
      }
      if (roles.length) {
        $scope.matter.users.push({
          id: user.id,
          roles,
          rate: !user.rate || user.rate.label == 'Standard' ? null : user.rate
        });
      }
    });
    if (!hasPrimary && $scope.matter.restricted) {
      $scope.addAlert('danger', "Restricted matters must have a 'Primary Responsible' assigned");
      return;
    }
    console.log('saving', $scope.matter);
    $scope.loading = true;
    $scope.buttonDisabled = true;
    const updateOrCreate = $scope.matter.id ? leanLawApi.updateMatter({
      id: $scope.matter.id,
      body: $scope.matter
    }) : leanLawApi.createMatter({
      body: $scope.matter
    });
    updateOrCreate.then(() => {
      accountingService.refresh();
      $state.go('^', {}, {
        reload: true
      });
    }, err => {
      $scope.loading = false;
      $scope.buttonDisabled = false;
      $scope.addAlert('danger', err.body.message);
    });
  };
  $scope.nameChange = function (item) {
    bootbox.confirm('This client is already in the system. Pick existing client instead of creating a new one?', result => {
      if (!result) return;
      $scope.matter.client = item;
      $state.go('^');
    });
  };
  $scope.saveClient = function () {
    console.log($scope.data.client);
    if ($scope.data.client && $scope.data.client.name.replace(/ /g, '')) {
      $scope.loadingClient = true;
      $scope.buttonDisabled = true;
      leanLawApi.createClient({
        body: $scope.data.client
      }).then(client => {
        $scope.loadingClient = false;
        $scope.buttonDisabled = false;

        // Update client list and select this client
        $scope.data.clients.push(client);
        $scope.matter.client = client;
        $state.go('matters.edit.info');
      }).catch(err => {
        $scope.loading = false;
        $scope.buttonDisabled = false;
        $scope.addAlert('danger', err.body.message);
      });
    } else {
      $scope.addAlert('danger', "Client name cannot be blank");
    }
  };
  $scope.fixedFeeChange = function () {
    $scope.matter.billing.fixed = angular.copy($scope.data.fixed);
  };
  $scope.clearStandard = function () {
    $scope.data.fixed = {
      label: null
    };
    $scope.matter.billing.fixed.label = null;
  };
  $scope.addStandard = function () {
    $state.go('matters.edit.addStandard');
  };
  $scope.saveStandard = function () {
    $scope.data.fixed = angular.copy($scope.matter.billing.fixed);
    if (!$scope.company.settings.fixedFees) {
      $scope.company.settings.fixedFees = [];
    }
    $scope.company.settings.fixedFees.push($scope.data.fixed);
    console.log('updating: ', $scope.company.settings.fixedFees);
    company.update({
      settings: {
        fixedFees: $scope.company.settings.fixedFees
      }
    }).then(company => {
      $state.go('matters.edit.info');
    }).catch(err => {
      let reason = "";
      if (err && err.body && err.body.message) {
        reason += `: ${err.body.message}`;
      }
      $scope.message = `Failed to save fixed fee${reason}`;
    });
  };
}]);